import { lazy } from "react";
import i18n from "i18next";
import type {
  GridSudokuDefinition,
  GridSudokuProgress,
  GridSudokuSubmission,
} from "@/lib/puzzle-format/types";
import type { PuzzleTypeModule } from "../types";
import type { GridSudokuPresence } from "./Player";
import { registerGridSudokuTranslations } from "./i18n";
import { localFeedback, loadEngine } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";

registerGridSudokuTranslations(i18n);
void loadEngine();

export const gridSudokuModule: PuzzleTypeModule<
  GridSudokuDefinition,
  GridSudokuSubmission,
  GridSudokuProgress,
  GridSudokuSubmission,
  GridSudokuPresence
> = {
  key: "grid_sudoku",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  localFeedback,
};
